import React from "react";
import Step from "@mui/material/Step";
import SystemCheck from "./SystemCheck";
import Instruction from "./Instruction";
import ConnectPhone from "./ConnectPhone";
import constants from "../../../constants";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";
import CameraPlacement from "./CameraPlacement";
import Acknowledgement from "./Acknowledgement";
import AlertContext from "../../../context/AlertContext";
import InstructionPageWizardHooks from "../../../Hooks/InstructionPage/InstructionPageWizardHooks";

export default function InstructionPageWizard() {
  const Alert = React.useContext(AlertContext);

  const InstructionPageWizardHks = InstructionPageWizardHooks();

  return (
    <div className="instructionPageWizardmainContainer">
      {Alert.testData.testmode !== constants.MODE.PRACTICE_MODE &&
        Alert.testData.proctored !== constants.PROCTORING_MODE.TAB &&
        Alert.testData.proctored !== constants.PROCTORING_MODE.NONE && (
          <>
            <div className="instructionPageWizardLabel">
              Before you start the test, let's ensure all the proctoring
              settings work properly.
            </div>
            <Stepper alternativeLabel activeStep={Alert.currentStep}>
              {InstructionPageWizardHks.steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                return (
                  <Step
                    key={index}
                    {...stepProps}
                    className="instructionPageWizardStepper"
                  >
                    <StepLabel
                      {...labelProps}
                      className="instructionPageWizardStepperLabel"
                    >
                      {label}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </>
        )}
      {Alert.testData.testmode === constants.MODE.PRACTICE_MODE ||
      Alert.testData.proctored === constants.PROCTORING_MODE.TAB ||
      Alert.testData.proctored === constants.PROCTORING_MODE.NONE ||
      InstructionPageWizardHks.steps[Alert.currentStep] === "Instructions" ? (
        <Instruction />
      ) : InstructionPageWizardHks.steps[Alert.currentStep] ===
        "Acknowledgement" ? (
        <Acknowledgement />
      ) : InstructionPageWizardHks.steps[Alert.currentStep] ===
        "System Check" ? (
        <SystemCheck />
      ) : InstructionPageWizardHks.steps[Alert.currentStep] ===
        "Connect Phone" ? (
        <ConnectPhone />
      ) : (
        InstructionPageWizardHks.steps[Alert.currentStep] ===
          "Camera Placement" && <CameraPlacement />
      )}
    </div>
  );
}
